import { NoInfer } from 'react-redux';

import { ActionReducerMapBuilder, Draft, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import {
  FulfilledActionType,
  PendingActionType,
  RejectedActionType,
  errorOr,
  fulfilled,
  pending,
  rejected
} from 'store/storeHelpers';

import { AktivitetsDomaner, ModelError, State } from 'models';

import BebyggelseApi from 'api/bebyggelseApi';

export const getAktivitetDomaner = createAsyncThunk<AktivitetsDomaner, undefined, { rejectValue: ModelError }>(
  'aktivitet/domaner/fetch',
  async (_undefined: undefined, { rejectWithValue }) => {
    const result = await BebyggelseApi.fetchAktivitetDomaner();
    return errorOr(result, rejectWithValue);
  }
);

const initialState: State<AktivitetsDomaner> = {
  data: undefined,
  error: undefined,
  requestStatus: 'idle',
  requestType: undefined,
  currentRequestId: undefined
};

const aktivitetDomanerSlice = createSlice({
  name: 'aktivitetDomaner',
  initialState,
  reducers: {},
  extraReducers: (builder: ActionReducerMapBuilder<NoInfer<State<AktivitetsDomaner>>>) => {
    builder.addCase(
      getAktivitetDomaner.pending,
      (state: Draft<State<AktivitetsDomaner>>, action: PendingActionType): void => pending(state, action)
    );
    builder.addCase(
      getAktivitetDomaner.fulfilled,
      (state: Draft<State<AktivitetsDomaner>>, action: FulfilledActionType<AktivitetsDomaner>): void => {
        action.payload = {
          aktivitettyper: action.payload.aktivitettyper.filter((aktivitetstyp) => aktivitetstyp.aktiv),
          aktivitetstatustyper: action.payload.aktivitetstatustyper.filter(
            (aktivitetstatustyp) => aktivitetstatustyp.aktiv
          ),
          beslutsorganisationer_bm: action.payload.beslutsorganisationer_bm.filter((bo) => bo.aktiv),
          beslutsorganisationer_sbm: action.payload.beslutsorganisationer_sbm.filter((bo) => bo.aktiv),
          skyddsklassningsaktiviteter: action.payload.skyddsklassningsaktiviteter.filter(
            (skyddsklassningstyp) => skyddsklassningstyp.aktiv
          )
        };
        fulfilled(state, action);
      }
    );
    builder.addCase(
      getAktivitetDomaner.rejected,
      (state: Draft<State<AktivitetsDomaner>>, action: RejectedActionType): void => rejected(state, action)
    );
  }
});

export default aktivitetDomanerSlice.reducer;
